var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "linked-record-cell",
      on: {
        mouseenter: function ($event) {
          _vm.showMenu = true
        },
        mouseleave: _vm.hideMenu,
      },
    },
    [
      _vm.linkedRecord
        ? _c(
            "div",
            {
              staticClass: "linked-record-info",
              on: {
                click: function ($event) {
                  return _vm.viewLinkedRecord(_vm.linkedRecord)
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("switch_access_shortcut"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "linked-record-label" }, [
                _vm._v(_vm._s(_vm.getLabel(_vm.linkedRecord))),
              ]),
            ]
          )
        : _c(
            "PermissionController",
            { attrs: { permissions: ["table.update"] } },
            [
              _c("a", { on: { click: _vm.showRecordPicker } }, [
                _vm._v("+ Kayıt Ekle"),
              ]),
            ]
          ),
      _vm._v(" "),
      _vm.showMenu && _vm.linkedRecord
        ? _c(
            "div",
            {
              staticClass: "linked-record-menu",
              on: { mouseenter: _vm.cancelHide, mouseleave: _vm.hideMenu },
            },
            [
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("SupsisButton", {
                    attrs: { icon: "edit", xxsmall: "" },
                    on: { click: _vm.editLinkedRecord },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "PermissionController",
                { attrs: { permissions: ["table.update"] } },
                [
                  _c("SupsisButton", {
                    attrs: { icon: "delete", xxsmall: "" },
                    on: { click: _vm.removeLinkedRecord },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: "Kayıt Seç",
                okText: "Kaydet",
                xlarge: "",
                className: "record-picker-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeModal },
            },
            [
              _c("RecordPicker", {
                attrs: {
                  "table-id": _vm.field.options.linkedRecord.table,
                  pickerMode: true,
                  labelFieldId: _vm.field.options.linkedRecord.labelField,
                },
                on: { "record-selected": _vm.onRecordSelected },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }